// 管理员维护
<template>
  <div>
    <c-table-search
      ref="tableSearch"
      :queryParams="queryParams"
      @doSearch="loadData"
    >
      <template v-slot:btns>
        <el-form-item>
          <el-button
            type="primary"
            @click="addAdmin"
          >添加管理员</el-button>
        </el-form-item>
      </template>
    </c-table-search>
    <c-table
      @handlePageChange="handlePageChange"
      :dataSource="dataSource"
      :pagination="pagination"
    >
      <template>
        <el-table-column
          prop="email"
          label="管理员邮箱"
        >
        </el-table-column>

        <el-table-column
          prop="userInfo.fullName"
          label="管理员姓名"
        >
        </el-table-column>

        <el-table-column
          prop="code"
          label="操作"
        >
          <template slot-scope="{row}">
            <div class="actions">
              <a @click="editAdmin(row)">编辑</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="resetPass(row)">密码重置</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="deleteAdmin(row)">删除</a>
            </div>

          </template>
        </el-table-column>
      </template>

    </c-table>

    <c-model
      ref="adminModel"
      title="管理员维护"
      @confirm="saveAdmin"
    >
      <el-form
        ref="adminForm"
        :model="adminInfo"
        label-width="100px"
      >
        <el-form-item
          label="管理员邮箱:"
          prop="email"
          required
        >
          <el-input v-model="adminInfo.email"></el-input>
        </el-form-item>

        <el-form-item
          label="管理员姓名:"
          prop="name"
          required
        >
          <el-input v-model="adminInfo.name"></el-input>
        </el-form-item>
      </el-form>

    </c-model>
  </div>

</template>

<script>
import { adminRes } from "@/api";
import TableMixin from "@/mixins/TableMixin";
export default {
  mixins: [TableMixin],
  data: function() {
    return {
      queryParams: [
        {
          label: "管理员姓名",
          code: "msg"
        }
      ],
      adminInfo: {
        name: "",
        email: ""
      }
    };
  },
  created() {},
  methods: {
    list(params) {
      console.log(params);
      var data = { ...params, pageSize: this.PAGE_SIZE };
      adminRes.getPage(data).then(res => {
        var { total, records } = res;
        this.pagination.total = total;
        this.dataSource = records;
      });
    },
    addAdmin() {
      this.adminInfo = {};
      this.openModel("adminModel");
    },
    editAdmin(row) {
      var obj = {
        id: row.id,
        email: row.email,
        name: row.userInfo.fullName
      };
      this.adminInfo = Object.assign({}, obj);
      this.openModel("adminModel");
    },
    saveAdmin() {
      this.$refs.adminForm.validate(valid => {
        if (valid) {
          adminRes.saveAdmin(this.adminInfo).then(res => {
            this.$refs.tableSearch.doSearch();
            this.closeModel("adminModel");
            this.$message.success("保存成功");
          });
        }
      });
    },
    resetPass(row) {
      this.$confirm("确认重置该管理员登录密码?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        adminRes.resetPass({ id: row.id }).then(res => {
          this.$message.success("重置成功");
        });
      });
    },
    deleteAdmin(row) {
      this.$confirm("确认删除该管理员?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        adminRes.deleteAdmin({ id: row.id }).then(res => {
          this.$refs.tableSearch.doSearch();
          this.$message.success("删除成功");
        });
      });
      console.log(record);
    }
  }
};
</script>
<style lang="scss" >
</style>


